(() => {
  const sections = [
    {
      title: 'Dane podstawowe',
      fields: [
        { name: 'name', label: 'Imię i nazwisko*', type: 'text', required: true },
        { name: 'email', label: 'Adres e-mail*', type: 'email', required: true },
        { name: 'age', label: 'Wiek', type: 'number' },
        { name: 'gender', label: 'Płeć', type: 'select', options: ['Kobieta', 'Mężczyzna'] },
        { name: 'weight', label: 'Waga', type: 'number' },
        { name: 'height', label: 'Wzrost w cm', type: 'number' },
        { name: 'phone', label: 'Numer kontaktowy', type: 'text' },
        { name: 'weight_change', label: 'Czy Twoja masa ciała w ostatnim roku zmieniała się znacząco? Jeśli tak, o ile kg?', type: 'text', wide: true },
        { name: 'activity_level', label: 'Jaki jest Twój obecny poziom aktywności fizycznej (niski, umiarkowany, wysoki)?', type: 'select', options: ['Niski', 'Umiarkowany', 'Wysoki'], wide: true }
      ]
    },
    {
      title: 'Historia medyczna',
      fields: [
        { name: 'chronic_diseases', label: 'Czy cierpisz na jakiekolwiek przewlekłe choroby? Jeśli tak, jakie?', type: 'text' },
        { name: 'autoimmune_diseases', label: 'Czy masz zdiagnozowane choroby autoimmunologiczne (np. Hashimoto, reumatoidalne zapalenie stawów)?', type: 'text' },
        { name: 'infections_operations', label: 'Czy w przeszłości przeszedłeś(-aś) poważne infekcje lub operacje? Jeśli tak, jakie i kiedy?', type: 'text' },
        { name: 'implants', label: 'Czy posiadasz implanty, protezy lub urządzenia medyczne (np. rozrusznik serca)?', type: 'text' },
        { name: 'family_history', label: 'Czy w Twojej rodzinie występują choroby genetyczne, przewlekłe lub nowotworowe? Jeśli tak, jakie?', type: 'text' },
        { name: 'diabetes', label: 'Czy masz zdiagnozowaną cukrzycę lub insulinooporność?', type: 'text' }
      ]
    },
    {
      title: 'Szczepienia i infekcje',
      fields: [
        { name: 'mandatory_vaccinations', label: 'Czy przyjąłeś(-aś) obowiązkowe szczepienia? Jeśli tak, wymień (jeśli pamiętasz)', type: 'text' },
        { name: 'additional_vaccinations', label: 'Czy przyjąłeś(-aś) dodatkowe szczepienia, np. przeciw COVID-19, grypie, HPV? Jeśli tak, kiedy?', type: 'text' },
        { name: 'vaccination_reactions', label: 'Czy kiedykolwiek miałeś(-aś) reakcje niepożądane na szczepienia? Jeśli tak, opisz.', type: 'text' },
        { name: 'viral_infections', label: 'Czy w przeszłości przechodziłeś(-aś) infekcje wirusowe (np. EBV, CMV, ospę, mononukleozę)?', type: 'text' },
        { name: 'frequent_infections', label: 'Czy często chorujesz na infekcje bakteryjne, wirusowe lub grzybicze?', type: 'text', wide: true }
      ]
    },
    {
      title: 'Styl życia',
      fields: [
        { name: 'typical_day', label: 'Jak wygląda Twój typowy dzień? (praca, nauka, aktywność fizyczna, odpoczynek)', type: 'text' },
        { name: 'sleep_meals', label: 'Ile godzin dziennie sypiasz? Czy jest to sen ciągły i regenerujący? Czy masz regularne godziny posiłków? Jeśli nie, dlaczego?', type: 'text' },
        { name: 'work_schedule', label: 'Czy pracujesz na zmiany, w nocy lub masz nieregularny harmonogram pracy?', type: 'text' },
        { name: 'stress_level', label: 'Jak oceniasz swój poziom stresu w skali od 1 do 10? Jak radzisz sobie ze stresem?', type: 'select', options: ['1','2','3','4','5','6','7','8','9','10'] },
        { name: 'physical_activity', label: 'Czy regularnie uprawiasz aktywność fizyczną? Jeśli tak, jaka to aktywność i jak często?', type: 'text' },
        { name: 'caffeine', label: 'Czy spożywasz napoje zawierające kofeinę (kawa, herbata, energetyki)? Jeśli tak, ile dziennie?', type: 'text' }
      ]
    },
    {
      title: 'Dieta i nawyki żywieniowe',
      fields: [
        { name: 'meals', label: 'Jak wygląda Twoje typowe śniadanie, obiad i kolacja?', type: 'text' },
        { name: 'snacking', label: 'Czy masz tendencję do podjadania między posiłkami? Jeśli tak, co najczęściej wybierasz?', type: 'text' },
        { name: 'dominant_products', label: 'Jakie produkty dominują w Twojej diecie (np. mięso, warzywa, nabiał, słodycze)?', type: 'text' },
        { name: 'elimination_diets', label: 'Czy stosujesz diety eliminacyjne (np. bezglutenowa, bezmleczna)? Jeśli tak, dlaczego?', type: 'text' },
        { name: 'food_symptoms', label: 'Czy zauważasz dolegliwości po spożyciu określonych produktów (np. mleka, glutenu)?', type: 'text' },
        { name: 'water', label: 'Ile wody wypijasz dziennie?', type: 'text' },
        { name: 'other_drinks', label: 'Czy pijesz inne napoje (np. soki, gazowane)?', type: 'text' },
        { name: 'supplements', label: 'Czy stosujesz suplementy diety? Jeśli tak, jakie i w jakiej dawce?', type: 'text' },
        { name: 'food_preferences', label: 'Jakie są Twoje preferencje żywieniowe (np. wegetarianizm, weganizm, dieta ketogeniczna)?', type: 'text', wide: true }
      ]
    },
    {
      title: 'Problemy zdrowotne i objawy',
      fields: [
        { name: 'digestive_problems', label: 'Czy masz problemy trawienne (np. wzdęcia, zaparcia, biegunki, refluks)? Jeśli tak, opisz.', type: 'text' },
        { name: 'hormonal_problems', label: 'Czy masz problemy hormonalne (np. nieregularne miesiączki, PMS, problemy z tarczycą)?', type: 'text' },
        { name: 'headaches', label: 'Czy cierpisz na bóle głowy lub migreny? Jeśli tak, jak często?', type: 'text' },
        { name: 'skin_problems', label: 'Czy zauważasz problemy ze skórą (np. trądzik, suchość, zaczerwienienia)?', type: 'text' },
        { name: 'hair_nails', label: 'Czy masz problemy z włosami (np. nadmierne wypadanie) lub paznokciami (np. łamliwość)?', type: 'text' },
        { name: 'fatigue', label: 'Czy często odczuwasz zmęczenie lub brak energii? Jeśli tak, o jakiej porze dnia?', type: 'text' },
        { name: 'concentration', label: 'Czy zauważasz u siebie trudności z koncentracją, pamięcią lub uczucie „mgły mózgowej”?', type: 'text' },
        { name: 'sleep_problems', label: 'Czy masz problemy ze snem, np. trudności z zasypianiem lub wybudzanie się w nocy?', type: 'text' }
      ]
    },
    {
      title: 'Badania laboratoryjne i diagnostyczne',
      fields: [
        { name: 'lab_results', label: 'Czy posiadasz aktualne wyniki badań (np. morfologia, TSH, witamina D, lipidogram)? Jeśli tak, załącz kopię', type: 'text', wide: true },
        { name: 'attachments', label: 'Załącz wyniki badań', type: 'file', wide: true, hint: 'Możesz dodać kilka plików. Maksymalny rozmiar jednego pliku: 4 MB.' },
        { name: 'allergy_tests', label: 'Czy kiedykolwiek wykonywałeś(-aś) testy alergiczne lub badania nietolerancji pokarmowych? Jeśli tak, jakie były wyniki?', type: 'text' },
        { name: 'parasite_tests', label: 'Czy byłeś(-aś) badany(-a) pod kątem pasożytów lub infekcji układu pokarmowego? Jeśli tak, opisz wyniki.', type: 'text' },
        { name: 'autoimmune_tests', label: 'Czy byłeś(-aś) badany(-a) pod kątem chorób autoimmunologicznych (np. ANA, przeciwciała przeciwko tarczycy)?', type: 'text', wide: true }
      ]
    },
    {
      title: 'Historia leczenia i suplementacji',
      fields: [
        { name: 'medications', label: 'Czy przyjmujesz obecnie jakiekolwiek leki? Jeśli tak, wymień je i podaj dawki.', type: 'text' },
        { name: 'self_supplementation', label: 'Czy kiedykolwiek stosowałeś(-aś) suplementy na własną rękę? Jeśli tak, jakie?', type: 'text' },
        { name: 'previous_consultations', label: 'Czy korzystałeś(-aś) wcześniej z porad dietetycznych lub konsultacji medycznych? Jeśli tak, jakie były ich efekty?', type: 'text', wide: true }
      ]
    },
    {
      title: 'Cele zdrowotne i oczekiwania',
      fields: [
        { name: 'health_goals', label: 'Jakie są Twoje główne cele zdrowotne? (np. poprawa samopoczucia, redukcja wagi, zwiększenie energii).', type: 'text' },
        { name: 'questions_concerns', label: 'Czy istnieją konkretne pytania lub obawy, które chciałbyś(-abyś) omówić podczas wizyty?', type: 'text' },
        { name: 'health_challenges', label: 'Jakie są Twoje największe wyzwania zdrowotne lub żywieniowe?', type: 'text' },
        { name: 'problematic_products', label: 'Czy są jakieś produkty lub grupy produktów, które szczególnie chciałbyś(-abyś) włączyć do swojej diety, ale są problematyczne?', type: 'text' }
      ]
    },
    {
      title: 'Informacje dodatkowe',
      fields: [
        { name: 'medical_checkups', label: 'Czy masz regularne wizyty kontrolne u lekarzy (np. endokrynologa, kardiologa)? Jeśli tak, jakie?', type: 'text' },
        { name: 'other_health_concerns', label: 'Czy masz jakiekolwiek obawy dotyczące swojego zdrowia, które nie zostały wymienione w ankiecie?', type: 'text' },
        { name: 'additional_information', label: 'Czy jest coś, co chciałbyś(-abyś) dodać lub co uważasz za istotne dla Twojej diagnozy?', type: 'text' },
        { name: 'quality_of_life', label: 'Jak oceniasz swoją jakość życia w skali od 1 do 10?', type: 'select', options: ['1','2','3','4','5','6','7','8','9','10'] }
      ]
    }
  ];

  const nkQuestionnaireEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
  const nkText = (pl, en) => nkQuestionnaireEnglish ? en : pl;
  if (nkQuestionnaireEnglish) {
    const sectionNames = ["Basic information","Medical history","Vaccinations and infections","Lifestyle","Diet and eating habits","Health concerns and symptoms","Laboratory tests and diagnostics","Treatment and supplement history","Health goals and expectations","Additional information"];
    const fieldNames = {"name":"Full name*","email":"Email address*","age":"Age","gender":"Gender","weight":"Weight","height":"Height in cm","phone":"Phone number","weight_change":"Has your weight changed significantly over the past year? If so, by how many kilograms?","activity_level":"What is your current level of physical activity (low, moderate, high)?","chronic_diseases":"Do you have any chronic conditions? If so, which ones?","autoimmune_diseases":"Have you been diagnosed with an autoimmune disease (for example Hashimoto disease or rheumatoid arthritis)?","infections_operations":"Have you had any serious infections or surgery? If so, what and when?","implants":"Do you have any implants, prostheses or medical devices (for example a pacemaker)?","family_history":"Is there a history of genetic conditions, chronic disease or cancer in your family? If so, which?","diabetes":"Have you been diagnosed with diabetes or insulin resistance?","mandatory_vaccinations":"Have you received the required vaccinations? If so, list them if you remember.","additional_vaccinations":"Have you received any additional vaccinations, for example against COVID-19, influenza or HPV? If so, when?","vaccination_reactions":"Have you ever had an adverse reaction to a vaccination? If so, please describe it.","viral_infections":"Have you had viral infections, for example EBV, CMV, chickenpox or mononucleosis?","frequent_infections":"Do you often have bacterial, viral or fungal infections?","typical_day":"What does a typical day look like for you (work, study, physical activity and rest)?","sleep_meals":"How many hours do you sleep each night? Is your sleep uninterrupted and restorative? Do you eat at regular times? If not, why?","work_schedule":"Do you work shifts or nights, or have an irregular work schedule?","stress_level":"How would you rate your stress level from 1 to 10? How do you manage stress?","physical_activity":"Do you exercise regularly? If so, what kind of activity and how often?","caffeine":"Do you drink caffeinated beverages (coffee, tea or energy drinks)? If so, how many per day?","meals":"What do you typically eat for breakfast, lunch and dinner?","snacking":"Do you snack between meals? If so, what do you usually choose?","dominant_products":"Which foods are most common in your diet (for example meat, vegetables, dairy or sweets)?","elimination_diets":"Do you follow any elimination diet (for example gluten-free or dairy-free)? If so, why?","food_symptoms":"Do you notice symptoms after eating specific foods (for example milk or gluten)?","water":"How much water do you drink each day?","other_drinks":"Do you drink other beverages (for example juices or soft drinks)?","supplements":"Do you take dietary supplements? If so, which ones and at what doses?","food_preferences":"Do you have any dietary preferences (for example vegetarian, vegan or ketogenic)?","digestive_problems":"Do you have digestive problems (for example bloating, constipation, diarrhea or reflux)? Please describe them.","hormonal_problems":"Do you have hormonal concerns (for example irregular periods, PMS or thyroid problems)?","headaches":"Do you have headaches or migraines? If so, how often?","skin_problems":"Do you have skin concerns (for example acne, dryness or redness)?","hair_nails":"Do you have hair concerns (for example excessive hair loss) or nail concerns (for example brittle nails)?","fatigue":"Do you often feel tired or low on energy? If so, at what time of day?","concentration":"Do you have difficulty concentrating or remembering things, or experience brain fog?","sleep_problems":"Do you have trouble sleeping, for example falling asleep or waking during the night?","lab_results":"Do you have recent test results (for example a complete blood count, TSH, vitamin D or a lipid panel)? If so, please attach a copy.","attachments":"Attach test results","allergy_tests":"Have you had allergy or food intolerance tests? If so, what were the results?","parasite_tests":"Have you been tested for parasites or digestive tract infections? If so, please describe the results.","autoimmune_tests":"Have you been tested for autoimmune diseases (for example ANA or thyroid antibodies)?","medications":"Are you currently taking any medication? If so, list the medicines and doses.","self_supplementation":"Have you ever taken supplements on your own? If so, which?","previous_consultations":"Have you previously received dietary advice or medical consultations? If so, what was the outcome?","health_goals":"What are your main health goals (for example feeling better, managing weight or increasing energy)?","questions_concerns":"Are there particular questions or concerns you would like to discuss during the consultation?","health_challenges":"What are your biggest health or nutrition challenges?","problematic_products":"Are there foods or food groups you would like to include in your diet but find problematic?","medical_checkups":"Do you have regular follow-up appointments with doctors (for example an endocrinologist or cardiologist)? If so, which?","other_health_concerns":"Do you have any health concerns not covered by this questionnaire?","additional_information":"Is there anything else you would like to add or consider important for your assessment?","quality_of_life":"How would you rate your quality of life from 1 to 10?"};
    const options = {Kobieta:'Female',Mężczyzna:'Male',Niski:'Low',Umiarkowany:'Moderate',Wysoki:'High'};
    sections.forEach((section, index) => {
      section.title = sectionNames[index];
      section.fields.forEach((field) => {
        if (!fieldNames[field.name]) throw new Error('Missing English questionnaire label: ' + field.name);
        field.label = fieldNames[field.name];
        if (field.options) field.options = field.options.map(value => options[value] || value);
        if (field.name === 'attachments') field.hint = 'You can attach several files. Maximum size per file: 4 MB.';
      });
    });
  }

  const createField = (field, index) => {
    const wrapper = document.createElement('div');
    wrapper.className = `health-questionnaire__field${field.wide ? ' health-questionnaire__field--wide' : ''}`;

    const id = `health-question-${index}`;
    const label = document.createElement('label');
    label.htmlFor = id;
    label.textContent = field.label;
    wrapper.appendChild(label);

    let control;
    if (field.type === 'select') {
      control = document.createElement('select');
      const blank = document.createElement('option');
      blank.value = '';
      blank.textContent = nkText('Wybierz', 'Choose');
      control.appendChild(blank);
      field.options.forEach((optionValue) => {
        const option = document.createElement('option');
        option.value = optionValue;
        option.textContent = optionValue;
        control.appendChild(option);
      });
    } else {
      control = document.createElement('input');
      control.type = field.type;
      if (field.type === 'number') { control.inputMode = 'decimal'; control.step = field.name === 'age' ? '1' : 'any'; control.min = '0'; }
      if (field.type === 'file') control.multiple = true;
    }

    control.id = id;
    control.name = field.type === 'file' ? 'contact[attachments]' : field.name;
    if (field.type === 'file') control.dataset.questionnaireAttachments = '';
    if (field.required) control.required = true;
    if (field.required) control.setAttribute('aria-required', 'true');
    wrapper.appendChild(control);

    if (field.hint) {
      const hint = document.createElement('p');
      hint.className = 'health-questionnaire__hint';
      hint.textContent = field.hint;
      wrapper.appendChild(hint);
    }

    return wrapper;
  };

  document.querySelectorAll('[data-health-questionnaire]').forEach((root) => {
    const form = root.querySelector('[data-health-questionnaire-form]') || root.querySelector('form.health-questionnaire__form');
    const fieldsRoot = root.querySelector('[data-health-questionnaire-fields]');
    const status = root.querySelector('[data-health-questionnaire-status]');
    const submitButton = root.querySelector('[data-health-questionnaire-submit]');
    const consentBlock = root.querySelector('.health-questionnaire__consent');
    const submitBlock = root.querySelector('.health-questionnaire__submit');
    if (!form || !fieldsRoot || !status || !submitButton || !consentBlock || !submitBlock) return;
    let fieldIndex = 0;
    let currentStep = 0;

    sections.forEach((section, sectionIndex) => {
      const group = document.createElement('fieldset');
      group.className = 'health-questionnaire__section';
      group.dataset.questionnaireStep = sectionIndex;
      group.hidden = sectionIndex !== 0;
      group.setAttribute('aria-hidden', sectionIndex === 0 ? 'false' : 'true');
      const header = document.createElement('div');
      header.className = 'health-questionnaire__section-header';
      const step = document.createElement('span');
      step.className = 'health-questionnaire__step';
      step.textContent = `${sectionIndex + 1} / ${sections.length}`;
      const legend = document.createElement('legend');
      legend.className = 'health-questionnaire__section-title';
      legend.textContent = section.title;
      header.append(step, legend);
      group.appendChild(header);
      const grid = document.createElement('div');
      grid.className = 'health-questionnaire__grid';
      section.fields.forEach((field) => grid.appendChild(createField(field, fieldIndex++)));
      group.appendChild(grid);
      fieldsRoot.appendChild(group);
    });

    const progress = document.createElement('div');
    progress.className = 'health-questionnaire__progress';
    progress.setAttribute('aria-live', 'polite');

    const progressCopy = document.createElement('div');
    progressCopy.className = 'health-questionnaire__progress-copy';
    const progressStep = document.createElement('span');
    progressStep.className = 'health-questionnaire__progress-step';
    const progressTitle = document.createElement('strong');
    progressTitle.className = 'health-questionnaire__progress-title';
    progressCopy.append(progressStep, progressTitle);

    const progressTrack = document.createElement('div');
    progressTrack.className = 'health-questionnaire__progress-track';
    progressTrack.setAttribute('role', 'progressbar');
    progressTrack.setAttribute('aria-valuemin', '1');
    progressTrack.setAttribute('aria-valuemax', String(sections.length));
    const progressBar = document.createElement('span');
    progressTrack.appendChild(progressBar);
    progress.append(progressCopy, progressTrack);
    fieldsRoot.before(progress);

    const navigation = document.createElement('div');
    navigation.className = 'health-questionnaire__navigation';
    const previousButton = document.createElement('button');
    previousButton.className = 'button button--secondary health-questionnaire__previous';
    previousButton.type = 'button';
    previousButton.textContent = nkText('Wstecz', 'Back');
    const nextButton = document.createElement('button');
    nextButton.className = 'button button--primary health-questionnaire__next';
    nextButton.type = 'button';
    nextButton.textContent = nkText('Dalej', 'Next');
    navigation.append(previousButton, nextButton);
    fieldsRoot.after(navigation);

    const stepGroups = Array.from(fieldsRoot.querySelectorAll('[data-questionnaire-step]'));

    const scrollToForm = () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      progress.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    };

    const showStep = (stepIndex, shouldScroll = true) => {
      currentStep = Math.max(0, Math.min(stepIndex, sections.length - 1));

      stepGroups.forEach((group, index) => {
        const isActive = index === currentStep;
        group.hidden = !isActive;
        group.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (isActive) {
          group.classList.remove('is-entering');
          window.requestAnimationFrame(() => group.classList.add('is-entering'));
        }
      });

      const isLastStep = currentStep === sections.length - 1;
      progressStep.textContent = nkText(`Krok ${currentStep + 1} z ${sections.length}`, `Step ${currentStep + 1} of ${sections.length}`);
      progressTitle.textContent = sections[currentStep].title;
      progressTrack.setAttribute('aria-valuenow', String(currentStep + 1));
      progressTrack.setAttribute('aria-valuetext', `${currentStep + 1} z ${sections.length}`);
      progressBar.style.width = `${((currentStep + 1) / sections.length) * 100}%`;

      previousButton.hidden = currentStep === 0;
      nextButton.hidden = isLastStep;
      consentBlock.hidden = !isLastStep;
      submitBlock.hidden = !isLastStep;
      navigation.classList.toggle('health-questionnaire__navigation--last', isLastStep);
      setStatus('', '');

      if (shouldScroll) scrollToForm();
    };

    const validateCurrentStep = () => {
      const controls = Array.from(stepGroups[currentStep].querySelectorAll('input, select, textarea'));
      const invalidControl = controls.find((control) => !control.checkValidity());
      if (!invalidControl) return true;

      invalidControl.reportValidity();
      invalidControl.focus();
      setStatus(nkText('Uzupełnij wymagane pola, aby przejść dalej.', 'Complete the required fields to continue.'), 'error');
      return false;
    };

    const setStatus = (message, state) => {
      status.textContent = message;
      status.dataset.state = state || '';
    };

    previousButton.addEventListener('click', () => showStep(currentStep - 1));
    nextButton.addEventListener('click', () => {
      if (validateCurrentStep()) showStep(currentStep + 1);
    });

    form.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || event.target.tagName === 'TEXTAREA' || currentStep === sections.length - 1) return;
      event.preventDefault();
      if (validateCurrentStep()) showStep(currentStep + 1);
    });

    showStep(0, false);
    let dirty=false;
    form.addEventListener('input',()=>{dirty=true});
    window.addEventListener('beforeunload',event=>{if(dirty){event.preventDefault();event.returnValue=''}});
    const notice=document.createElement('p');
    notice.textContent=nkText('Odpowiedzi zostaną przekazane dopiero po kliknięciu WYŚLIJ na ostatnim kroku. Nie zamykaj ani nie odświeżaj strony przed potwierdzeniem wysłania. Ze względów prywatności nie zapisujemy danych zdrowotnych na tym urządzeniu.', 'Your answers are sent only when you click SUBMIT on the last step. Do not close or refresh the page until the submission is confirmed. For privacy reasons, we do not save health data on this device.');
    notice.className='health-questionnaire__privacy-note';progress.after(notice);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      setStatus('', '');

      if (currentStep !== sections.length - 1) {
        if (validateCurrentStep()) showStep(currentStep + 1);
        return;
      }

      if (!form.reportValidity()) {
        const invalidControl = form.querySelector(':invalid');
        const invalidStep = invalidControl && invalidControl.closest('[data-questionnaire-step]');
        if (invalidStep) showStep(Number(invalidStep.dataset.questionnaireStep), false);
        if (invalidControl) invalidControl.focus();
        setStatus(nkText('Uzupełnij wymagane pola i zaznacz zgodę.', 'Complete the required fields and tick the consent box.'), 'error');
        return;
      }

      const fileInput = form.querySelector('[data-questionnaire-attachments]');
      const files = fileInput && fileInput.files ? Array.from(fileInput.files) : [];
      const oversized = files.find((file) => file.size > 4 * 1024 * 1024);
      if (oversized) {
        setStatus(nkText(`Plik „${oversized.name}” przekracza limit 4 MB.`, `File “${oversized.name}” exceeds the 4 MB limit.`), 'error');
        fileInput.focus();
        return;
      }

      const totalSize = files.reduce((sum, file) => sum + file.size, 0);
      if (totalSize > 16 * 1024 * 1024) {
        setStatus(nkText('Łączny rozmiar załączników nie może przekroczyć 16 MB.', 'The combined attachment size cannot exceed 16 MB.'), 'error');
        fileInput.focus();
        return;
      }

      const answers = [];
      sections.forEach((section) => {
        answers.push(`\n${section.title.toUpperCase()}`);
        section.fields.forEach((field) => {
          if (field.type === 'file') return;
          const control = form.elements[field.name];
          answers.push(`${field.label}\n${control && control.value ? control.value : '—'}`);
        });
      });
      if (files.length) answers.push(`\n${nkText('ZAŁĄCZNIKI', 'ATTACHMENTS')}\n${files.map((file) => file.name).join(', ')}`);

      form.querySelector('[data-questionnaire-contact-name]').value = form.elements.name.value;
      form.querySelector('[data-questionnaire-contact-email]').value = form.elements.email.value;
      form.querySelector('[data-questionnaire-contact-phone]').value = form.elements.phone.value;
      form.querySelector('[data-questionnaire-contact-body]').value = answers.join('\n');
      submitButton.disabled = true;
      setStatus(nkText('Wysyłamy ankietę…', 'Sending your questionnaire…'), '');

      try {
        const endpoint = root.dataset.healthQuestionnaireEndpoint;
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form), signal: AbortSignal.timeout(60000),
        });
        if (!response.ok || (await response.json()).ok !== true) throw new Error('Submission failed');

        dirty=false; form.reset();
        setStatus(nkText('Dziękujemy. Ankieta została wysłana bezpośrednio do Natalii.', 'Thank you. Your questionnaire has been sent directly to Natalia.'), 'success');
      } catch (error) {
        submitButton.disabled = false;
        setStatus(nkText('Nie udało się wysłać ankiety. Spróbuj ponownie za chwilę lub napisz na konsultacje@nkutyla.com.', 'Your questionnaire could not be sent. Please try again shortly or write to konsultacje@nkutyla.com.'), 'error');
      }
    });
  });
})();
